module.exports = __webpack_public_path__ + "img/product_115.3cef760.webp";